import {RootState} from './interfaces'

export const moneyTokenSelector = (state: RootState) => state.moneyToken
